export default __webpack_public_path__ + "static/media/web-img.99df4de0.svg";